import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import BookingNoteItem from "./BookingNoteItem";

function BookingNotesList({
  notes,
  currentUserId,
  now,
  formatTimestamp,
  onUpdated,
  onDeleted,
}) {
  const { t } = useTranslation();
  const endRef = useRef(null);
  const noteIds = notes.map((note) => note.id).join(",");

  useEffect(() => {
    if (endRef.current) {
      endRef.current.scrollIntoView({ block: "end" });
    }
  }, [noteIds]);

  return (
    <div className="bd-notes-list" role="log" aria-live="polite">
      {notes.map((note) => (
        <BookingNoteItem
          key={note.id}
          note={note}
          currentUserId={currentUserId}
          now={now}
          formatTimestamp={formatTimestamp}
          onUpdated={onUpdated}
          onDeleted={onDeleted}
        />
      ))}
      {notes.length === 0 ? (
        <p className="bd-notes-empty">{t("No notes yet.")}</p>
      ) : null}
      <div ref={endRef} />
    </div>
  );
}

export default BookingNotesList;
